// extracted by mini-css-extract-plugin
export default {"subject":"SubjectBlock_subject__VCE7B","subjectHeader":"SubjectBlock_subjectHeader__LPKIf","rowActions":"SubjectBlock_rowActions__sHpR9"};